import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { get } from '../../../utils/getPropertyByPath';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { ReactComponent as ChevronArrowDown } from '../../../resources/icons/chevron-bold.svg';
import { ReactComponent as Shuffle } from '../../../resources/icons/shuffle.svg';
import getListing from '../../../utils/getListing';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
var SurpriseWizardPOI = function SurpriseWizardPOI(_ref) {
  var preselectedPOIS = _ref.preselectedPOIS,
    algoliaIndexes = _ref.algoliaIndexes,
    shuffleText = _ref.shuffleText,
    selectNames = _ref.selectNames,
    queryParams = _ref.queryParams,
    removedOldQueryString = _ref.removedOldQueryString,
    isPreselectedValueExists = _ref.isPreselectedValueExists,
    eventsAnalytics = _ref.eventsAnalytics,
    params = _ref.params;
  var sitecoreContext = useSitecoreContext();
  var algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    skipFirstLoad = _useState2[0],
    setSkipFirstLoad = _useState2[1];
  var getPreselectedPOIS = function getPreselectedPOIS(preselectedPOIS) {
    return preselectedPOIS.map(function (poi) {
      return {
        url: get(poi, "url") || null,
        urlSlug: get(poi, "fallbackImage.jss.value.alt") || null,
        category: get(poi, "category.jss.fields.Title.value") || null,
        title: get(poi, "title.jss.value") || null,
        src: get(poi, "fallbackImage.jss.value.src") || null
      };
    });
  };
  var _useState3 = useState(function () {
      return getPreselectedPOIS(preselectedPOIS);
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    POIs = _useState4[0],
    setPOIs = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    page = _useState6[0],
    setPage = _useState6[1];
  var gridArray = ["a", "b", "c", "d"];
  var requestToAlgolia = function requestToAlgolia() {
    var forceRequest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var tag = selectNames.reduce(function (acc, name) {
      if (queryParams[name]) {
        // @ts-ignore
        acc.push("tags: ".concat(queryParams[name]));
      }
      return acc;
    }, []);
    var itemFilters = {
      facetFilters: [tag, ["type: POI"]],
      hitsPerPage: 4,
      page: page
    };
    var itemFiltersForForceRequest = {
      facetFilters: [["type: POI"]],
      hitsPerPage: 4,
      page: page
    };
    var getPOIFromHits = function getPOIFromHits(hits) {
      return hits.map(function (hit) {
        return {
          url: hit.url,
          urlSlug: hit.urlSlug,
          category: hit.category ? hit.category[0] : null,
          title: hit.title,
          src: hit.image
        };
      });
    };
    var POIRequest = function POIRequest(itemForFilters) {
      getListing(algoliaIndexes, itemForFilters, algoliaSettings).then(function (response) {
        setPOIs(getPOIFromHits(response.hits));
        setPage(function (prev) {
          return response.nbPages <= prev + 1 ? 0 : ++prev;
        });
      }).catch(function (error) {
        console.log("error", error);
      });
    };
    if (tag.length) {
      POIRequest(itemFilters);
      return;
    }
    if (forceRequest) {
      POIRequest(itemFiltersForForceRequest);
      return;
    }
  };
  var handleShuffle = function handleShuffle() {
    requestToAlgolia(true);
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ShuffleButtonClickAnalytics'], params), shuffleText.toUpperCase());
  };
  useEffect(function () {
    if (skipFirstLoad && isPreselectedValueExists || removedOldQueryString) {
      requestToAlgolia();
    }
    setSkipFirstLoad(false);
  }, [queryParams]);
  var analyticsImageHandle = function analyticsImageHandle(e, text) {
    e.stopPropagation();
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ImageClickAnalytics'], params), text);
  };
  var analyticsArrowHandle = function analyticsArrowHandle(e, text) {
    e.stopPropagation();
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ImageArrowClickAnalytics'], params), text);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, POIs.map(function (_ref2, index) {
    var url = _ref2.url,
      urlSlug = _ref2.urlSlug,
      category = _ref2.category,
      title = _ref2.title,
      src = _ref2.src;
    return /*#__PURE__*/React.createElement("div", {
      className: "POICardWrapper ".concat(gridArray[index]),
      style: {
        backgroundImage: "url(".concat(src, ")")
      },
      key: index,
      onClick: function onClick(e) {
        return analyticsImageHandle(e, "".concat(category, " : ").concat(urlSlug));
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: url,
      className: "POICardWrapperLink",
      onClick: function onClick(e) {
        return analyticsArrowHandle(e, "".concat(category, " : ").concat(urlSlug));
      }
    }, category ? /*#__PURE__*/React.createElement("p", {
      className: "category"
    }, category.toUpperCase()) : null, /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, /*#__PURE__*/React.createElement("p", {
      className: "title"
    }, title), /*#__PURE__*/React.createElement("span", {
      className: "circleLink"
    }, /*#__PURE__*/React.createElement(ChevronArrowDown, {
      className: "arrowIcon"
    })))));
  }), /*#__PURE__*/React.createElement("div", {
    className: "f"
  }, /*#__PURE__*/React.createElement("button", {
    className: "shuffle",
    onClick: handleShuffle
  }, /*#__PURE__*/React.createElement(Shuffle, {
    className: "shuffleIcon"
  }), shuffleText.toUpperCase())));
};
export { SurpriseWizardPOI };